import 'src/assets/css/bmi-fonts.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'prismjs/prism';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-jsx';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import 'src/__mocks__';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import * as serviceWorker from 'src/serviceWorker';
import { PersistGate } from 'redux-persist/integration/react';
import { SettingsProvider } from 'src/contexts/SettingsContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import App from 'src/App';
import { store, persistor } from './store/store';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <ToastContainer />
        <SettingsProvider>
          <App />
        </SettingsProvider>
      </PersistGate>
    </Provider>
  </HelmetProvider>
);

serviceWorker.register();
